import { AxiosResponse } from 'axios';
import { appContextGet } from './httpCommon/appAxios.service';
import { ON_FARM_SPECIMEN_API_ENDPOINTS } from '../constants/apiEndpoints';
import { OnFarmSpecimen } from '../types/interfaces/onFarmSpecimen.interfaces';
import { PagedResponse, StandardParams } from '../types/interfaces/apiParams.interfaces';

export const getOnFarmSpecimenById = (
  onFarmSpecimenId: number | string,
  params?: StandardParams,
): Promise<AxiosResponse<OnFarmSpecimen>> => {
  return appContextGet(`${ON_FARM_SPECIMEN_API_ENDPOINTS.SPECIMENS_}${onFarmSpecimenId}`, params);
};

export const getOnFarmSpecimens = (
  params?: StandardParams,
): Promise<AxiosResponse<OnFarmSpecimen[] | PagedResponse<OnFarmSpecimen>>> => {
  return appContextGet(ON_FARM_SPECIMEN_API_ENDPOINTS.SPECIMENS, params);
};

export const getOnFarmSpecimensByAccountId = (
  accountId: number | string,
  params?: StandardParams,
): Promise<AxiosResponse<OnFarmSpecimen[] | PagedResponse<OnFarmSpecimen>>> => {
  return appContextGet(`${ON_FARM_SPECIMEN_API_ENDPOINTS.SPECIMENS_BY_ACCOUNT}${accountId}`, params);
};

export const getOnFarmSpecimensByAnimalId = (
  animalId: number | string,
  params?: StandardParams,
): Promise<AxiosResponse<OnFarmSpecimen[]>> => {
  return appContextGet(`${ON_FARM_SPECIMEN_API_ENDPOINTS.SPECIMENS_BY_ANIMAL}${animalId}`, params);
};
